/*
  System Info State - Mutations.
*/

import { v4 as uuidv4 } from 'uuid';
import {
  CHANGE_FILTER,
  CHANGE_PAGINATION,
  GET_AUDIT_LOG_DATA,
  TOGGLE_AUDIT_LOG_TABLE_LOADING,
  GET_SYSTEM_SETTINGS_DATA,
  GET_FEATURE_FLAGS_DATA,
  SET_FEATURE_FLAG_DATA,
  TOGGLE_FEATURE_FLAGS_LOADING,
  TOGGLE_SYSTEM_SETTINGS_LOADING,
  SET_TEST_EMAIL_MODAL_STATE,
  COLLECT_SYSTEM_SETTINGS_REQUEST_DATA,
} from './mutation-types';

/* ---------------------------------------------------------- */

export default {

  [GET_AUDIT_LOG_DATA](state, data) {
    state.auditLog.data = data;
  },
  [TOGGLE_AUDIT_LOG_TABLE_LOADING](state, param) {
    state.auditLog.loading = param;
  },
  [CHANGE_PAGINATION](state, params) {
    state.auditLog.pagination = { ...params };
  },
  [CHANGE_FILTER](state, params) {
    state.auditLog.filter = { ...params };
  },
  [GET_SYSTEM_SETTINGS_DATA](state, payload) {
    state.systemSettings.data = payload;
  },
  [TOGGLE_SYSTEM_SETTINGS_LOADING](state, payload) {
    state.systemSettings.loading = payload;
  },
  [SET_TEST_EMAIL_MODAL_STATE](state, payload) {
    state.systemSettings.testEmailModal.isOpen = payload;
  },
  [COLLECT_SYSTEM_SETTINGS_REQUEST_DATA](state, payload) {
    state.systemSettings.requestData = payload;
  },

  /* ---------------------------------------------------------- */
  /* Feature Flags */

  [TOGGLE_FEATURE_FLAGS_LOADING](state, payload) {
    state.systemSettings.featureFlagsLoadingState = payload;
  },

  /**
   * Store the Feature Flags data in the State.
   * - Add missing Flags with default values.
      * @param {*} state System Info data.
   * @param {*} payload Feature Flags array. 
   */
  [GET_FEATURE_FLAGS_DATA](state, payload) {
    /* Fill in the gaps with any missing flags. NB Added flags only appear on database once user changes value on System Settings. */
    if (!payload.find(ff => ff.name === state.systemSettings.featureFlagNames.fieldCalc_RowFormula)) {
      payload.push({
        guid: uuidv4(),
        name: state.systemSettings.featureFlagNames.fieldCalc_RowFormula,
        description: 'Field Calculation - Row Formula',
        enabled: false,
        visible: true,
      });
    }
    if (!payload.find(ff => ff.name === state.systemSettings.featureFlagNames.fieldCalc_Aggregation)) {
      payload.push({
        guid: uuidv4(),
        name: state.systemSettings.featureFlagNames.fieldCalc_Aggregation,
        description: 'Field Calculation - Aggregation - Same Table',
        enabled: false,
        visible: true,
      });
    }
    if (!payload.find(ff => ff.name === state.systemSettings.featureFlagNames.fieldCalc_MdmAggregation)) {
      payload.push({
        guid: uuidv4(),
        name: state.systemSettings.featureFlagNames.fieldCalc_MdmAggregation,
        description: 'Field Calculation - Aggregation - Other Table',
        enabled: false,
        visible: true,
      });
    }
    if (!payload.find(ff => ff.name === state.systemSettings.featureFlagNames.fieldCalc_AIChat)) {
      payload.push({
        guid: uuidv4(),
        name: state.systemSettings.featureFlagNames.fieldCalc_AIChat,
        description: 'Field Calculation - AI Chat',
        enabled: false,
        visible: true,
      });
    }
    /* Assign Feature Flags to State. */
    state.systemSettings.featureFlags = payload;
  },

  /**
   * Store the Feature Flag in the State.
   * - Existing Flag data is replaced.
   * @param {*} state System Info data.
   * @param {*} payload Feature Flag data.
   */
  [SET_FEATURE_FLAG_DATA](state, payload) {
    const idx = state.systemSettings.featureFlags.findIndex(ff => ff.name === payload.name);
    if (idx >= 0)
      state.systemSettings.featureFlags.splice(idx, 1, payload);
    else if (!!payload.name)
      state.systemSettings.featureFlags.push(payload);
  },

  /* ---------------------------------------------------------- */

};

/* ---------------------------------------------------------- */
